import React from 'react';
import { SidebarHeader, SidebarHeaderSection } from '@99designs/feature-file-overlay';
import { FullscreenSidebarBody } from '@99designs/spa-common';
import { FullscreenSidebarMain } from '@99designs/spa-common';
import { FullscreenSidebarHeader } from '@99designs/spa-common';
import DesignerDetailsBody from './DesignerDetailsBody';
import DesignerDetailsHeader from './DesignerDetailsHeader';
import { Designer } from './types';

interface SidebarProps {
    designer: Designer;
    pitch?: string;
    jobId?: string;
    closeOverlayHandler: () => void;
    onSelectDesigner: () => void;
}

function Sidebar({ designer, pitch, jobId, closeOverlayHandler, onSelectDesigner }: SidebarProps) {
    return (
        <FullscreenSidebarMain>
            <FullscreenSidebarHeader backgroundColor="white">
                <SidebarHeader closeOverlayHandler={closeOverlayHandler}>
                    <SidebarHeaderSection showDivider={false}>
                        <DesignerDetailsHeader
                            designer={designer}
                            onSelectDesigner={onSelectDesigner}
                            jobId={jobId}
                        />
                    </SidebarHeaderSection>
                </SidebarHeader>
            </FullscreenSidebarHeader>
            <FullscreenSidebarBody>
                <DesignerDetailsBody designer={designer} pitch={pitch} jobId={jobId} />
            </FullscreenSidebarBody>
        </FullscreenSidebarMain>
    );
}
export default Sidebar;
